import { runInAction } from 'mobx';
import { ocapiClient } from '../../../../api-clients/ocapi/client';
import { isEmptyArray } from '../../../../utils/array-utils';
import { logger } from '../../../../utils/logger';
import { getOrder } from '../../selectors/order/get-order';
import { getOrderSelections } from '../../selectors/order/get-order-selections';
import { orderDomainStore } from '../../store';
import { mapOrderItemLineToOrderItemRequest } from '../../utils/items/mappers/map-order-item-line-to-order-item-request';
import { assertIsStandardOrGiftShopOrder } from '../../utils/order-type-utils';
import { registerOrderAction } from '../utils/register-order-action';
import { syncOrder } from '../utils/sync-order';
export const saveOrderItems = async () => {
    const order = getOrder();
    assertIsStandardOrGiftShopOrder(order, 'Cannot save items');
    const orderSelections = getOrderSelections();
    if (!orderSelections.items) {
        logger.debug('Cannot save items. Items are already in sync with the API.');
        return;
    }
    if (isEmptyArray(orderSelections.items) && isEmptyArray(order.items)) {
        logger.debug('Cannot save items. No items selected.');
        return;
    }
    const deregisterAction = registerOrderAction('save-selected-order-items');
    try {
        const response = await ocapiClient.instance.v1.orders.items.set(order.id, {
            items: orderSelections.items.map(mapOrderItemLineToOrderItemRequest)
        });
        syncOrder(response);
    }
    finally {
        deregisterAction();
    }
    runInAction(() => {
        orderDomainStore.data.selections.items = undefined;
    });
};
